import type { SealConfig } from '$store/loaders/seals.tsx'
import type { Product } from 'apps/commerce/types.ts'

export interface UseSealsProps {
    seals?: SealConfig[]
    product: Product
}
export function useSeals({ seals = [], product }: UseSealsProps) {
    const { additionalProperty = [], inProductGroupWithID = 0 } = product

    const filteredSeals = seals.filter(({ matchers = [] }) => {
        return matchers.some(({ matcherType, id }) => {
            if (matcherType === 'product') {
                return Number(id) === Number(inProductGroupWithID)
            }

            return additionalProperty.some(({ name, propertyID }) => {
                return name === matcherType && propertyID === String(id)
            })
        })
    })

    return { filteredSeals }
}
